import { Pipe, PipeTransform } from '@angular/core';
import { EventType, VideoType } from '../../@generated';

@Pipe({
    name: 'typeToString'
})
export class TypeToStringPipe implements PipeTransform {

    transform(value: VideoType | EventType): string {
        switch (value) {
            case VideoType.Interview:
                return 'Interview';
            case VideoType.Tutorial:
                return 'Tutorial';
            case VideoType.Debate:
                return 'Debate';
            case VideoType.Seminar:
                return 'Seminar';
            case VideoType.Conference:
                return 'Conference';
            case VideoType.Workshop:
                return 'Workshop';
            case VideoType.Webinar:
                return 'Webinar';
            case VideoType.LectureSeries:
                return 'Lecture Series';
            case EventType.Conference:
                return 'Conference';
            case EventType.Webinar:
                return 'Webinar';
            case EventType.Workshop:
                return 'Workshop';
            case EventType.Seminar:
                return 'Seminar';
            case EventType.LectureSeries:
                return 'Lecture Series';
            case EventType.Debate:
                return 'Debate';
            case EventType.Interviews:
                return 'Interviews';
            case EventType.Tutorial:
                return 'Tutorial';
            default:
                return 'Unknown';

        }
    }
}
